import { render, staticRenderFns } from "./ContestJudgeFormComponent.vue?vue&type=template&id=3bbb053f"
import script from "./ContestJudgeFormComponent.vue?vue&type=script&lang=js"
export * from "./ContestJudgeFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestJudgeFormComponent.vue?vue&type=style&index=0&id=3bbb053f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports